import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IField, IGroup } from '../../document-type-settings.dto';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentTypeAbstractComponent } from '../../document-type-abstract.component';
import { FormBuilder } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { GlobalService } from 'app/global/global.service';
import { CustomColumnService } from 'app/main/pages/contract-control/custom-column-service/custom-column.service';
import { DocumentListingApiService } from 'app/main/pages/documents/document-listing.api.service';
import { DocumentListingFacade } from 'app/main/pages/documents/store/document-listing.facade';
import { DocumentFieldService } from 'app/main/pages/settings/documentfields/documentfield.service';
import { SharedStoreFacade } from 'app/main/shared/shared/store/shared-store.facade';
import { DocumentTypeService } from '../../../document-type.service';
import { TabStateService } from '../../tab-state.service';
import { DocumentTypeFacade } from '../../../store/document-type.facade';
import { filter, takeUntil } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DocumentTypeGroupEnum } from '../../default-constants/document-type-settings.constants';
import { CustomBoxBuilderService } from '../custom-box/custom-box-builder.service';
import { IDocumentTypesDto } from 'app/main/pages/documents/dto/document-listing.dto';

@Component({
  selector: 'app-overview-group',
  templateUrl: './overview-group.component.html',
  styleUrl: '../contract-control-edit-layout.component.scss'
})

export class OverviewGroupComponent extends DocumentTypeAbstractComponent implements OnInit {

  @Output() updateFieldsOrders = new EventEmitter<{ nestedTab: string, fields: IField[] }>();
  @Output() updateGroupsOrders = new EventEmitter<IGroup[]>();
  @Input() groups: IGroup[];
  @Input() disabledAccordionSection: string[] =[];
  @Input() allowSectionDragAndDrop: boolean = false;
  @Input() settings: IDocumentTypesDto;
  @Input() allowVisibilityChange: boolean = false;
  public activeGroupIds: string[] = [];
  public dynamicSectionsList = [DocumentTypeGroupEnum.TopSection, DocumentTypeGroupEnum.DocumentField];
  public addFieldButtonTextKeys ={
    [DocumentTypeGroupEnum.TopSection]: "Document type setting - modal - document section (Document type section) - Add Index Field",
    [DocumentTypeGroupEnum.DocumentField]: "Document type setting - modal - Preview section (Document type section) - Add field button",
  }


  constructor(
    protected _activeModal: NgbActiveModal,
    protected _modalService: NgbModal,
    protected _coreSidebarService: CoreSidebarService,
    protected _globalService: GlobalService,
    protected _documentTypeService: DocumentTypeService,
    protected _documentListingApiService: DocumentListingApiService,
    protected _store: Store,
    protected _documentFieldService: DocumentFieldService,
    protected _documentFacade: DocumentListingFacade,
    protected _customColumnService: CustomColumnService,
    protected _transloco: TranslocoService,
    protected _formBuilder: FormBuilder,
    protected _sharedStoreFacade: SharedStoreFacade,
    protected _documentTypeFacade: DocumentTypeFacade,
    protected _tabStateService: TabStateService,
    protected _customBoxBuilderService: CustomBoxBuilderService
  ) {
    super(
      _activeModal,
      _modalService,
      _coreSidebarService,
      _globalService,
      _documentTypeService,
      _documentListingApiService,
      _store,
      _documentFieldService,
      _documentFacade,
      _customColumnService,
      _transloco,
      _formBuilder,
      _sharedStoreFacade,
      _tabStateService,
      _documentTypeFacade,
      _customBoxBuilderService
    );
  }


  ngOnInit(): void {
    this.documentTypeSettings = structuredClone(this.settings);
  }



  /**
   * Handles the drop event for reordering fields within the overview group.
   * Clones the current fields array, moves the dragged item to its new position,
   * updates the order property for each field, and emits the updated fields order.
   *
   * @param event - The drag-and-drop event containing previous and current indices.
   */
  drop(event: CdkDragDrop<string[]>, group: IGroup): void {
    const fields = structuredClone(group.fields);
    moveItemInArray(fields, event.previousIndex, event.currentIndex);
    fields.forEach((box, index) => box.order = index);
        
    this.updateFieldsOrders.emit({ 
       nestedTab: group.name,
       fields: fields
    });
  }



    dropGroup(event: CdkDragDrop<string[]>): void {
      if( this.allowSectionDragAndDrop === false ) {
          return;
      }

      const groups = structuredClone(this.groups);
      moveItemInArray(groups, event.previousIndex, event.currentIndex);
      groups.forEach((box, index) => box.order = index);
      this.updateGroupsOrders.emit(groups);
  }

  /**
   * Toggles the expansion state of an accordion group by its ID.
   * 
   * If the specified group ID is already active, it will be removed from the list of active group IDs (collapsed).
   * Otherwise, it will set the active group IDs to only include the specified ID (expanding it and collapsing others).
   * 
   * @param id - The unique identifier of the accordion group to toggle.
   */
  onAccordionToggle(id: string): void {
    if (this.activeGroupIds.includes(id)) {
      this.activeGroupIds = this.activeGroupIds.filter(x => x !== id);
    } else {
      this.activeGroupIds = [id];
    }
  }

  updateFieldStatus(isVisible:boolean, field: IField, group: IGroup): void {
     const fields = structuredClone(group.fields);

     const fieldIndex = fields.findIndex(f => f.field_name === field.field_name);

      if (fieldIndex !== -1) {
          fields[fieldIndex].status = isVisible;           
           this.updateFieldsOrders.emit({ 
              nestedTab: group.name,
              fields: fields
              });
        }
  }
}
